<template>
    <div
        class="c-switch-select"
        :class="{
            'is-disabled': isAddressesDisabled,
            'is-initial': isInitialAddressesFetch,
        }"
    >
        <template v-if="isInitialAddressesFetch">
            <div class="c-switch-select__trigger" />
        </template>

        <template v-else>
            <div class="c-switch-select__trigger" :class="{ 'is-active': isAddressSelectOpen }">
                <button
                    type="button"
                    class="c-btn"
                    @click="toggleAddressSelect()"
                >
                    <div class="sc-info" :class="{'is-pickup': selectedAddress.isStorePickup}">
                        <span class="sc-info__key" v-html="getTriggerAddressName(selectedAddress)"></span>

                        <span class="sc-info__value" v-html="getTriggerAddressValue(selectedAddress)"></span>
                    </div>

                    <i class="ico ico-chevron-down" aria-hidden="true"></i>
                </button>
            </div>

            <div class="c-switch-select__list" v-if="isAddressSelectOpen">
                <div
                    class="c-switch-select__list__item"
                    v-for="address in filteredAddresses"
                    :key="address.id"
                >
                    <button
                        type="button"
                        class="c-btn"
                        :class="{ 'is-selected': address.id == selectedAddressId }"
                        :id="address.id"
                        @click="changeAddress(address.id)"
                    >
                        <div class="sc-info" :class="{'is-pickup': address.isStorePickup}">
                            <span class="sc-info__key" v-html="getAddressName(address)"></span>

                            <span class="sc-info__value" v-html="getAddressValue(address)"></span>
                        </div>
                    </button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
    data() {
        return {
            isAddressSelectOpen: false,
        };
    },
    mounted() {
        document.addEventListener("click", this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    methods: {
        getTriggerAddressName(address) {
            if (this.selectedAddressIsInActiveTab) {
                return this.getAddressName(address);
            } else {
                return "";
            }
        },
        getAddressName(address) {
            if (address.isStorePickup) {
                return address.address;
            }

            if (!address.data) {
                return null;
            }

            if (address.data.company && address.data.company.trim() !== "") {
                return address.data.company;
            }

            if (address.data.name && address.data.name.trim() !== "") {
                return address.data.name;
            }

            return null;
        },
        getTriggerAddressValue(address) {
            if (this.selectedAddressIsInActiveTab) {
                return this.getAddressValue(address);
            } else {
                return this.$t("Switch.Addresses.selectPlaceholder");
            }
        },
        getAddressValue(address) {
            if (address.isStorePickup) {
                return address.city;
            }

            if (!address.data) {
                return "";
            }

            let value = "";

            if (this.shopType === "b2c" && address.data.company && address.data.company.trim() !== "" && address.data.name && address.data.name.trim() !== "") {
                value += `<span class="sc-contact">${address.data.name}</span><br>`;
            }

            value += `${address.data.address}, ${address.data.post_code} ${address.data.city}`;

            return value;
        },
        toggleAddressSelect() {
            this.isAddressSelectOpen = !this.isAddressSelectOpen;
        },
        changeAddress(addressId) {
            this.$store.dispatch("changeAddress", addressId);
            this.isAddressSelectOpen = false;
        },
        handleClickOutside(event) {
            if (this.isAddressSelectOpen && !this.$el.contains(event.target)) {
                this.isAddressSelectOpen = false;
            }
        },
    },
    computed: {
        ...mapState([
            "isInitialAddressesFetch",
            "isAddressesDisabled",
            "selectedAddressId",
            "shopType",
        ]),
        ...mapGetters([
            "filteredAddresses",
            "selectedAddress",
            "selectedAddressIsInActiveTab",
        ]),
    },
};
</script>